/* The client's phone — the frame's box, the glass under it and the island over it, from
 * `profile-web-mockups-v2/f-zakladki.html` (`.ip`, `.screen`), transcribed value for value. The
 * percentages are the PNG's own geometry (554 x 1156), which is layout rather than a token.
 *
 * `--drop-phone` is neutral: the coloured-glow ban has one exception in this app and it is the
 * ember primary. */

/* The frame's box. The aspect ratio is the PNG's own (554 x 1156), so the display-area percentages
 * below land where the glass is however tall the column lets it be. */
.phone {
  position: relative;
  flex: none;
  aspect-ratio: 554 / 1156;
  filter: var(--drop-phone);
}

/* The frame, OVER the glass. Its display area is a transparent, antialiased hole, so the bezel is
 * what masks the screen's corners — which is why it is painted last and why it carries no
 * `photoBox` ground: a fill behind a cut-out shows through the hole as a grey pane.
 * `pointer-events: none` so the picture of a phone is never something to drag. */
.frame {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  pointer-events: none;
  user-select: none;
}

/* The glass, UNDER the frame and half a percent larger than the hole on every side: black, the
 * phone's own bezel between the metal and the display, so the frame's thin black ring reads as the
 * edge of a thicker black border rather than of the display itself.
 *
 * The hole measures left 4.513%, top 1.730%, width 90.975%, height 96.367% of the frame's box, with a
 * corner of about 62px of its 554 x 1156 (measured on the PNG's alpha, 27 September 2026); each
 * number below is that one grown by the bleed, so this layer's edge is always behind the bezel. */
.glass {
  position: absolute;
  top: 1.23%;
  left: 4.013%;
  width: 91.975%;
  height: 97.367%;
  background: var(--phone-island);
  border-radius: var(--ph-radius-screen);
}

/* The display, INSIDE the hole with a margin of 6px of the PNG's 554 (1.083% across, 0.519% down),
 * its corner concentric with the bezel's (`--ph-radius-display`, measured on the rendered page). The
 * owner, 27 September 2026: at the old size the display filled the hole to the bezel's curve, so
 * in the corners the white met the frame's thin ring and read as covering it. Now a black border
 * of even width stands between the two on every side, the corners included. */
.screen {
  position: absolute;
  top: 2.249%;
  left: 5.596%;
  width: 88.809%;
  height: 95.329%;
  overflow: hidden;
  color: var(--phone-text);
  background: var(--phone-bg);
  border-radius: var(--ph-radius-display);
  container-type: inline-size;
}

/* ABOVE the frame, because the island is part of what was cut out. The mockup states it against the
 * SCREEN (top 2.35%, width 33%, height 3.5%); against the frame box those become
 * 1.23 + 2.35% x 97.367 = 3.53% down, 33% x 91.975 = 30.35% wide and 3.5% x 97.367 = 3.41% tall. */
.island {
  position: absolute;
  top: 3.53%;
  left: 50%;
  z-index: 3;
  width: 30.35%;
  height: 3.41%;
  background: var(--phone-island);
  border-radius: var(--r-pill);
  transform: translateX(-50%);
}

.status {
  position: absolute;
  top: var(--ph-space-11);
  right: var(--ph-space-13);
  left: var(--ph-space-13);
  display: flex;
  justify-content: space-between;
  font-size: var(--ph-fs-body);
  font-weight: var(--fw-bold);
}

